/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CentreData } from './CentreData';
import {
    CentreDataFromJSON,
    CentreDataFromJSONTyped,
    CentreDataToJSON,
    CentreDataToJSONTyped,
} from './CentreData';

/**
 * 
 * @export
 * @interface DailyOverviewData
 */
export interface DailyOverviewData {
    /**
     * 
     * @type {number}
     * @memberof DailyOverviewData
     */
    ordersTotal?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyOverviewData
     */
    ordersReceived?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyOverviewData
     */
    ordersCompleted?: number;
    /**
     * 
     * @type {number}
     * @memberof DailyOverviewData
     */
    ordersCancelled?: number;
    /**
     * 
     * @type {Array<CentreData>}
     * @memberof DailyOverviewData
     */
    centres?: Array<CentreData>;
}

/**
 * Check if a given object implements the DailyOverviewData interface.
 */
export function instanceOfDailyOverviewData(value: object): value is DailyOverviewData {
    return true;
}

export function DailyOverviewDataFromJSON(json: any): DailyOverviewData {
    return DailyOverviewDataFromJSONTyped(json, false);
}

export function DailyOverviewDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DailyOverviewData {
    if (json == null) {
        return json;
    }
    return {
        
        'ordersTotal': json['ordersTotal'] == null ? undefined : json['ordersTotal'],
        'ordersReceived': json['ordersReceived'] == null ? undefined : json['ordersReceived'],
        'ordersCompleted': json['ordersCompleted'] == null ? undefined : json['ordersCompleted'],
        'ordersCancelled': json['ordersCancelled'] == null ? undefined : json['ordersCancelled'],
        'centres': json['centres'] == null ? undefined : ((json['centres'] as Array<any>).map(CentreDataFromJSON)),
    };
}

export function DailyOverviewDataToJSON(json: any): DailyOverviewData {
    return DailyOverviewDataToJSONTyped(json, false);
}

export function DailyOverviewDataToJSONTyped(value?: DailyOverviewData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ordersTotal': value['ordersTotal'],
        'ordersReceived': value['ordersReceived'],
        'ordersCompleted': value['ordersCompleted'],
        'ordersCancelled': value['ordersCancelled'],
        'centres': value['centres'] == null ? undefined : ((value['centres'] as Array<any>).map(CentreDataToJSON)),
    };
}

